import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Search from "./pages/Search";
import CauseForm from "./pages/CauseForm";
import CauseDetail from "./pages/CauseDetail";
import WorkOrderForm from "./pages/WorkOrderForm";
import WorkOrderDetail from "./pages/WorkOrderDetail";
import TemplateLibrary from "./pages/TemplateLibrary";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/search"
            element={
              <ProtectedRoute>
                <Dashboard><Search /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/causes/new"
            element={
              <ProtectedRoute>
                <Dashboard><CauseForm /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/causes/:id"
            element={
              <ProtectedRoute>
                <Dashboard><CauseDetail /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/causes/:id/work-orders/new"
            element={
              <ProtectedRoute>
                <Dashboard><WorkOrderForm /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/work-orders/:id"
            element={
              <ProtectedRoute>
                <Dashboard><WorkOrderDetail /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Dashboard><TemplateLibrary /></Dashboard>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

// build cache buster 2026-04-17
